/**
 * 特殊文字を HTML 文字に変換します。
 *
 * @param input
 */
const htmlEscape = input => {
  return input
    .replace(/&#38;/g, "&")
    .replace(/&#60;/g, "<")
    .replace(/&#62;/g, ">")
    .replace(/&#34;/g, '"')
    .replace(/&#39;/g, "'");
};

// HTMLElement が画面の下にはみ出るか判定
const isBottomOverflow = (
  element // HTMLElement を想定。{getBoundingClientRect: () => { bottom: number; }};
) => {
  if (!element) return false;
  if (!window) return false; // window オブジェクトが参照できるところで使用する想定
  const rect = element.getBoundingClientRect();
  return rect.bottom > window.innerHeight; // boolean;
};

export default {
  htmlEscape,
  isBottomOverflow,
};
